import React from "react";
import {Image} from "antd";
import useTranslate from "../../../../../modules/local/useTranslate";
import {ImagePlaceholder} from "../../../../../conts/imageBase64";
import {BsMegaphoneFill} from "react-icons/bs";
import {
    AnnouncementLinkButton,
    AnnouncementMessage,
    AnnouncementMetaLine,
    AnnouncementTypeBadge,
    renderAnnouncementTimeSection,
} from "../../../../../components/Feed/AnnouncementCardHelpers";
import {TYPE_COLORS} from "../../../../Organization/components/OrganizationAnnouncementItem";

// Card nội dung thông báo owner_type=course_class trong feed - DÙNG CHUNG khối chip ngữ cảnh
// (Lớp/Chuyên đề)/dòng "Người nhận"/nút mở link/khối thời gian với OrganizationAnnouncementItem
// (owner_type organization/group/course) qua AnnouncementCardHelpers.js, tránh 2 nguồn logic hiển
// thị khác nhau cho cùng 1 khái niệm Announcement. Màu sắc dùng chung TYPE_COLORS.DEFAULT (type_code
// ở phạm vi lớp/khóa lấy từ lookup động do admin tự đặt tên, không có set màu/icon cố định như bên
// tổ chức WEDDING/BAPTISM... - xem comment icon trong OrganizationAnnouncementItem.js).
export const CourseClassAnnouncementItem = ({item}) => {

    const t = useTranslate()
    const {
        title, type_label, photo,
        content,
        time_close, time_open, shared_url,
    } = item ?? {}

    const colors = TYPE_COLORS.DEFAULT

    return (
        <div className="flex flex-col border border-color-50 background-50 rounded-xl relative">
            {photo ? (
                <div className="relative">
                    <Image
                        src={photo}
                        fallback={ImagePlaceholder}
                        style={{maxHeight: 420}}
                        wrapperClassName="w-full mx-auto rounded-t-xl"
                        className="object-cover w-full rounded-t-xl"
                        preview={false}
                    />
                    {type_label && (
                        <div className="absolute top-3 left-3">
                            <AnnouncementTypeBadge icon={<BsMegaphoneFill/>} label={type_label} colors={colors} overlay/>
                        </div>
                    )}
                </div>
            ) : type_label && (
                <div className="p-3">
                    <AnnouncementTypeBadge icon={<BsMegaphoneFill/>} label={type_label} colors={colors}/>
                </div>
            )}
            <div className="p-3 flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <AnnouncementMetaLine item={item} t={t}/>
                    <div className="font-bold text-base leading-snug text-color-000">
                        {title}
                    </div>
                    <AnnouncementMessage content={content} colors={colors}/>
                    <AnnouncementLinkButton shared_url={shared_url} colors={colors} t={t}/>
                </div>
                {(time_open || time_close) && renderAnnouncementTimeSection({time_open, time_close, t})}
            </div>
        </div>
    )

}
